import "./Faculty.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { AxiosInstance } from "../../../../axios";
import moment from "moment";
import { validateSalary } from "./validation";
import DatePickerSample from "../../DatePicker";
import MonthDatePicker from "../../MonthDatePicker";
import toast from "react-hot-toast";

function AddSalary() {
  const location = useLocation();
  const formFields = location.state?.formFields;
  const inputRef = useRef(null);
  const display_processed_date = useRef(null);
  const display_start_date = useRef(null);
  const display_end_date = useRef(null);
  const display_month = useRef(null);
  const { staff_id, staff_type, amount, id } = useParams();

  const navigate = useNavigate();

  const [fData, setFormData] = useState({
    Date: "",
    MonthOf: "",
    TSalary: staff_type === "0" ? "" : amount,
    deduction: "",
    THSalary: "",
    eDate: "",
    no_class: "",
    salaryBased: "0",
    sDate: "",
    per_class_amount: "",
    description: "",
  });

  useEffect(() => {
    if (formFields?.payment_mode) {
      let salaryBasedValue = "0";

      if (formFields.payment_mode === "Month") salaryBasedValue = "1";
      else if (formFields.payment_mode === "Others") salaryBasedValue = "2";

      setFormData((prev) => ({
        ...prev,
        ...formFields,
        salaryBased: salaryBasedValue,
      }));
    }
  }, []);

  const [error, setError] = useState({});

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let user_type = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    userid = user?.user_id || null;
    user_type = user?.user_type || null;
  }

  // ------------------------- LOAD EDIT DATA ----------------------------
  useEffect(() => {
    if (!id) return;

    AxiosInstance.post("api/staff/salary/findById", { id })
      .then((res) => {
        if (res.data.status === true) {
          const el = res.data.data[0];

          let salaryBasedValue = "0";
          if (el.payment_mode === "Month") salaryBasedValue = "1";
          else if (el.payment_mode === "Others") salaryBasedValue = "2";

          setFormData((prev) => ({
            ...prev,
            Date: el.processed_date
              ? moment(el.processed_date).format("DD/MM/YYYY")
              : "",
            MonthOf: el.month_of || "",
            TSalary: el.tot_salary || "",
            deduction: el.deduction || "",
            THSalary: el.takehome_salary || "",
            sDate: el.start_date
              ? moment(el.start_date).format("DD/MM/YYYY")
              : "",
            eDate: el.end_date ? moment(el.end_date).format("DD/MM/YYYY") : "",
            no_class: el.no_of_class || "",
            description: el.description || "",
            salaryBased: salaryBasedValue,
            per_class_amount: el.salary_per_class || "",
          }));
        }
      })
      .catch((error) => console.log(error));
  }, [id]);

  // ---------------------- AUTO CALCULATE NO. OF CLASSES -----------------
  useEffect(() => {
    if (id) return;

    if (fData.sDate && fData.eDate) {
      AxiosInstance.post("api/staff/salary/classList", {
        staff_id: parseInt(staff_id),
        start_date: moment(fData.sDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
        end_date: moment(fData.eDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
        salary_per_class: fData.per_class_amount,
      }).then((res) => {
        if (res.data.status === true) {
          setFormData((prev) => ({
            ...prev,
            no_class: res.data.data.no_of_class,
            TSalary: res.data.data.tot_salary,
          }));
        }
      });
    }
  }, [fData.sDate, fData.eDate]);

  const navigateToPreviousScreen = () => {
    navigate(-1);
  };

  // -------------------------- DATE HANDLER ------------------------------
  const handleChangeCuDate = (date, name) => {
    const formatted = date ? moment(date).format("DD/MM/YYYY") : "";

    if (name === "sDate") {
      setFormData((prev) => ({
        ...prev,
        sDate: formatted,
        eDate: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: formatted,
      }));
    }

    setError((prev) => ({ ...prev, [name]: "" }));
  };

  // -------------------------- MONTH HANDLER ------------------------------
  const handleEYDates = (dated, name) => {
    const value = moment(dated).format("YYYY-MM");
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError((prev) => ({ ...prev, [name]: "" }));
  };

  // -------------------------- INPUT CHANGE -------------------------------
  const handleChange = (event) => {
    const { name, value } = event.target;

    // Deduction logic
    if (name === "deduction") {
      if (value === "") {
        setFormData((prev) => ({ ...prev, deduction: "" }));
        return;
      }

      const deductionValue = Number(value);
      const totalSalary = Number(fData.TSalary || 0);

      setFormData((prev) => ({ ...prev, deduction: deductionValue }));
      if (deductionValue > totalSalary) {
        return setError((prev) => ({
          ...prev,
          deduction: "Deduction should not be greater than total salary",
        }));
      }

      return setError((prev) => ({ ...prev, deduction: "" }));
    }

    if (name === "salaryBased") {
      return setFormData({
        Date: "",
        MonthOf: "",
        TSalary: staff_type === "0" ? "" : amount,
        deduction: "",
        THSalary: "",
        eDate: "",
        no_class: "",
        sDate: "",
        per_class_amount: "",
        description: "",
        salaryBased: value,
      });
    }

    if (name === "no_class") {
      const num = Number(value);
      const per = Number(fData.per_class_amount || 0);

      setFormData((prev) => ({
        ...prev,
        no_class: value,
        TSalary: num * per,
      }));

      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ---------------------------- SUBMIT ----------------------------------
  const handleSubmit = () => {
    const errors = validateSalary(fData, staff_type);

    if (Object.keys(errors).length > 0) return setError(errors);

    const payload = {
      staff_id: staff_id,
      start_date: fData.sDate
        ? moment(fData.sDate, "DD/MM/YYYY").format("YYYY-MM-DD")
        : null,
      end_date: fData.eDate
        ? moment(fData.eDate, "DD/MM/YYYY").format("YYYY-MM-DD")
        : null,
      processed_date: fData.Date
        ? moment(fData.Date, "DD/MM/YYYY").format("YYYY-MM-DD")
        : null,
      no_of_class: fData.no_class || 0,
      month_of: fData.MonthOf || null,
      tot_salary: fData.TSalary || 0,
      deduction: fData.deduction || 0,
      takehome_salary:
        (Number(fData.TSalary) || 0) - (Number(fData.deduction) || 0),
      description: fData.description || "",
      staff_type: staff_type,
      salary_per_class: fData.per_class_amount || 0,
    };

    if (id) {
      payload.id = id;
      payload.updated_by = userid;

      AxiosInstance.post("api/staff/salary/edit", payload).then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          navigateToPreviousScreen();
        }
      });
    } else {
      payload.created_by = userid;

      AxiosInstance.post("api/staff/salary/add", payload).then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          navigateToPreviousScreen();
        } else toast.error(res.data.message);
      });
    }
  };

  // ---------------------------- UI --------------------------------------
  return (
    <div className="Faculty ">
      <div className="row">
        <div className="col-md-12">
          <section className="StepOne ">
            <div className="heading mt-3 d-flex justify-content-between">
              {id ? (
                <h4 className={user_type === 3 ? "STitless" : "STitles"}>
                  Edit Salary
                </h4>
              ) : (
                <h4 className={user_type === 3 ? "STitless" : "STitles"}>
                  Add New Salary
                </h4>
              )}

              <Link
                to="javascript:void(0)"
                onClick={navigateToPreviousScreen}
                className="CancelButton"
              >
                {user_type === 3
                  ? "Back to Home"
                  : `Back to View ${
                      staff_type === "0"
                        ? "Faculty"
                        : staff_type === "1"
                        ? "Staff"
                        : "Panel Member"
                    }`}{" "}
              </Link>

              <button
                type="button"
                className="SaveButton"
                onClick={handleSubmit}
              >
                <Link to="javascript:void(0)">
                  {id ? "Update Salary" : "Save Salary"}
                </Link>
              </button>
            </div>

            <div className="row box ">
              <div className="col-md-12">
                <p className="StepTitle">Salary Details</p>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <div className="forms">
                      <label>Processed Date</label>
                      <DatePickerSample
                        txtAdMDob={display_processed_date}
                        name="Date"
                        handleChange={handleChangeCuDate}
                        fieldInput={fData.Date || ""}
                      />
                      {error.Date && (
                        <small className="error">{error.Date}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="forms">
                      <label>Salary Based on</label>
                      <select
                        className="Inputs"
                        id="salaryBased"
                        value={fData.salaryBased}
                        onChange={handleChange}
                        name="salaryBased"
                      >
                        <option value="0">Number of Classes</option>
                        <option value="1">Month</option>
                        <option value="2">Others</option>
                      </select>
                      {error.salaryBased && (
                        <small className="error">{error.salaryBased}</small>
                      )}
                    </div>
                  </div>

                  {fData.salaryBased === "0" && (
                    <div className="col-md-6">
                      <div className="forms">
                        <label>Salary Per Class</label>
                        <input
                          type="number"
                          className="Inputs"
                          name="per_class_amount"
                          value={fData.per_class_amount}
                          onChange={handleChange}
                          placeholder="Enter the Salary Per Class"
                        />
                        {error.per_class_amount && (
                          <small className="error">
                            {error.per_class_amount}
                          </small>
                        )}
                      </div>
                    </div>
                  )}

                  {(fData.salaryBased === "0" || fData.salaryBased === "2") && (
                    <div className="col-md-6">
                      <div className="forms">
                        <label>Start Date</label>
                        <DatePickerSample
                          txtAdMDob={display_start_date}
                          name="sDate"
                          handleChange={handleChangeCuDate}
                          fieldInput={fData.sDate || ""}
                        />
                        {error.sDate && (
                          <small className="error">{error.sDate}</small>
                        )}
                      </div>
                    </div>
                  )}

                  {fData.salaryBased === "0" && (
                    <div className="col-md-6">
                      <div className="forms">
                        <label>End Date</label>
                        <DatePickerSample
                          txtAdMDob={display_end_date}
                          name="eDate"
                          handleChange={handleChangeCuDate}
                          minDate={fData.sDate}
                          fieldInput={fData.eDate || ""}
                        />
                        {error.eDate && (
                          <small className="error">{error.eDate}</small>
                        )}
                      </div>
                    </div>
                  )}

                  {fData.salaryBased === "0" && (
                    <div className="col-md-6">
                      <div className="forms">
                        <label>Number of Classes</label>
                        <input
                          type="number"
                          className="Inputs"
                          name="no_class"
                          value={fData.no_class}
                          disabled={!fData.per_class_amount}
                          onChange={handleChange}
                          placeholder="Enter Number of Classes"
                        />
                        {error.no_class && (
                          <small className="error">{error.no_class}</small>
                        )}
                      </div>
                    </div>
                  )}

                  {fData.salaryBased === "1" && (
                    <div className="col-md-6">
                      <div className="forms">
                        <label>For the Month of</label>
                        <MonthDatePicker
                          txtAdSpass={display_month}
                          name="MonthOf"
                          handleChange={handleEYDates}
                          fieldInput={fData.MonthOf}
                        />
                        {error.MonthOf && (
                          <small className="error">{error.MonthOf}</small>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="col-md-6">
                    <div className="forms">
                      <label>Total Salary</label>
                      <input
                        type="number"
                        className="Inputs"
                        name="TSalary"
                        value={fData.TSalary}
                        disabled={fData.salaryBased === "0"}
                        onChange={handleChange}
                        placeholder="Enter the Total Salary"
                      />
                      {error.TSalary && (
                        <small className="error">{error.TSalary}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="forms">
                      <label>Deduction</label>
                      <input
                        type="number"
                        className="Inputs"
                        name="deduction"
                        value={fData.deduction}
                        onChange={handleChange}
                        placeholder="Enter the Deduction"
                      />
                      {error.deduction && (
                        <small className="error">{error.deduction}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="forms">
                      <label>Take Home Salary</label>
                      <input
                        type="number"
                        className="Inputs"
                        value={
                          (Number(fData.TSalary) || 0) -
                          (Number(fData.deduction) || 0)
                        }
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="forms">
                      <label>Description</label>
                      <textarea
                        rows="3"
                        className="Inputs"
                        name="description"
                        value={fData.description}
                        onChange={handleChange}
                        placeholder="Enter the description"
                      ></textarea>

                      {error.description && (
                        <small className="error">{error.description}</small>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddSalary;
